import $ from "jquery";
import _ from "underscore";
import Backbone from "backbone";

const AlertView = Backbone.View.extend({
  tagName: "div",
  className: "alert-container",
  template: _.template(
    [
      "<div class='alert'>",
      "<button type='button' class='close fui-cross'></button>",
      "<h3><%= title %></h3>",
      "<p><%= message %></p>",

      "<% if (input){ %>",
      "<input class='alert-input-field input form-control mtm' type='text' value='<%= input_default %>'>",
      "<% } %>",

      "<% if (type == 'email'){ %>",
      "<div class='form-group'>",
      "<input class='alert-email-field input form-control mtm' type='email' value='<%= input_default %>' placeholder='E-post'>",
      "</div>",
      "<% } %>",

      "<% if (type == 'date') { %>",
      "<div class='form-group'>",
      "<input class='alert-date-field date form-control' type='text' value='<%= input_default %>' data-toggle='datepicker'>",
      "</div>",
      "<% } %>",

      "<% if (type == 'select'){ %>",
      "<form class='base-form'>",
      "<select class='alert-select-field select form-control'>",
      "<% _.each(select_options, function(option){ %>",
      "<option value='<%- option[0] %>'<% if (select_default == option[0]) { %> selected='selected'<% } %>><%= option[1] %></option>",
      "<% }) %>",
      "</select>",
      "</form>",
      "<% } %>",

      "<% if (slider){ %>",
      "<div class='clearfix'>",
      "<div class='slider-label slider-min-label'><%= slider.min %> <%= slider.unit %></div>",
      "<div class='slider-label slider-max-label'><%= slider.max %> <%= slider.unit %></div>",
      "</div>",
      "<div class='alert-slider'></div>",
      "<p>",
      "<span><%= slider.text_before %></span>",
      "<span class='slider-value-label'><%= slider.value %></span>",
      "<span><%= slider.text_after %></span>",
      "</p>",
      "<% } %>",

      "<div class='alert-buttons'></div>",
      "</div>",
      "<div class='alert-modal'></div>",
    ].join("\n")
  ),

  events: {
    "click .close": "close",
  },

  initialize: function (options) {
    _.bindAll(this, "render");
    if (options) {
      this.type = options.type || "info";
      this.title = options.title || "";
      this.input = options.input || false;
      this.select_options = options.select_options || [];
      this.select_default = options.select_default || false;
      this.input_default = options.input_default || "";
      this.slider = options.slider || false;
      this.message = options.message || "";
      this.fixed = typeof options.fixed !== "undefined" ? options.fixed : true;
      this.buttons = options.buttons || [];
      this.width = options.width;
      this.additional_classes = options.additional_classes || false;
      this.empty_value = options.empty_value || false;
    }
  },

  center_position: function () {
    var $alert = this.$el.find(".alert");
    $alert.css("margin-top", -$alert.height() / 2 + "px");
  },

  render: function () {
    var _this = this,
      output = this.template({
        title: this.title,
        message: this.message,
        input: this.input,
        input_default: this.input_default,
        type: this.type,
        select_options: this.select_options,
        select_default: this.select_default,
        slider: this.slider,
      });
    this.$el.html(output);

    var $alert = this.$el.find(".alert");

    if (this.type == "input") {
      $alert.addClass("alert-info");
    } else {
      $alert.addClass("alert-" + this.type);
    }

    if (this.additional_classes) {
      $alert.addClass(this.additional_classes);
    }
    if (this.fixed) {
      $alert.addClass("fixed");
    }
    if (this.width === "auto") {
      $alert.width("auto");
    } else if (this.width) {
      $alert
        .width(this.width + "px")
        .css("margin-left", -(this.width / 2) + "px");
    }

    var $bn_container = this.$el.find(".alert-buttons");
    _.each(this.buttons, function (button) {
      var $bn = $("<button type='button'></button>")
        .text(button.text)
        .addClass("btn")
        .addClass("btn-wide");
      if (button.type) {
        $bn.addClass("btn-" + button.type);
      }

      button.$el = $bn;

      $bn_container.append($bn);
      $bn.on("click", function () {
        if (button.validator && !button.validator(_this)) {
          return;
        }

        _this.close();
        if (button.callback) {
          button.callback(_this);
        }
      });
    });

    // Close alert on escape key
    $(document).on("keyup", this.on_keyup.bind(this));

    if (this.slider) {
      this.$slider_value = this.$el.find(".slider-value-label");
      this.$slider = this.$el.find(".alert-slider");
      this.$slider.slider(
        $.extend(this.slider, {
          slide: function (event, ui) {
            _this.$slider_value.text(ui.value);
          },
        })
      );
    }

    return this;
  },

  on_keyup: function (e) {
    if (e.keyCode == 27) {
      this.close();
    } else if (e.keyCode == 13) {
      var primaryBtn = _.find(this.buttons, function (btn) {
        return btn.type == "success" || btn.type == "primary";
      });
      if (primaryBtn) {
        primaryBtn.$el.trigger("click");
        e.preventDefault();
        e.stopPropagation();
      }
    }
  },

  close: function () {
    // Unbind events
    $(document).off("keyup", $.proxy(this.on_keyup, this));

    this.remove();
  },
});

AlertView.show = function (option) {
  var alert = new AlertView(option);
  $(document.body).append(alert.render().el);
  document.activeElement.blur();
  alert.center_position();
  return alert;
};

AlertView.showError = function (title, message) {
  var alert = new AlertView({
    title: title,
    message: message,
    type: "error",
  });
  $(document.body).append(alert.render().el);
  document.activeElement.blur();
  return alert;
};
AlertView.confirm = function (title, message, callback) {
  var alert = new AlertView({
    title: title,
    message: message,
    type: "info",
    buttons: [
      {
        text: "Ja",
        type: "info",
        callback: callback,
      },
      {
        text: "Nej",
      },
    ],
  });
  $(document.body).append(alert.render().el);
  document.activeElement.blur();
  return alert;
};
AlertView.confirmObject = function (data) {
  var alert = new AlertView({
    title: data.title || "Bekräfta",
    message: data.message || "Vill du verkligen fortsätta?",
    additional_classes: data.additional_classes || false,
    type: "info",
    buttons: [
      {
        text: "Ja",
        type: data.btn_type || "primary",
        callback: function () {
          if (data.callback) data.callback();
        },
      },
      {
        text: "Nej",
      },
    ],
  });
  $(document.body).append(alert.render().el);
  document.activeElement.blur();
  return alert;
};

AlertView.buttonsConfirm = function (data) {
  var alert = new AlertView({
    title: data.title || "Bekräfta",
    message: data.message || "Vill du verkligen fortsätta?",
    additional_classes: data.additional_classes || false,
    width: data.width || "auto",
    type: "info",
    buttons: data["buttons"].map((options) => {
      return {
        text: options.text,
        type: options.btn_type || "primary",
        callback: function () {
          if (options.callback) options.callback();
        },
      };
    }),
  });
  $(document.body).append(alert.render().el);
  document.activeElement.blur();
  return alert;
};

AlertView.input = function (title, message, input_default, callback) {
  var alert = new AlertView({
    title: title,
    message: message,
    type: "input",
    input: true,
    input_default: input_default,
    buttons: [
      {
        text: "Ok",
        type: "primary",
        callback: function (alert_view) {
          callback($(alert_view.el).find(".alert-input-field").val());
        },
      },
      {
        text: "Avbryt",
        type: "default",
      },
    ],
  });
  $(document.body).append(alert.render().el);
  document.activeElement.blur();
  alert.$el.find(".alert-input-field").focus();
  return alert;
};

// TODO: convert all .input to .inputObject and remove em..
AlertView.inputObject = function (data) {
  var alert = new AlertView({
    title: data.title || "Fyll i värde",
    message: data.message || "Ange värdet i fältet",
    additional_classes: data.additional_classes || false,
    type: "input",
    input: true,
    input_default: data.input_default || "",
    buttons: [
      {
        text: "Ok",
        type: "primary",
        callback: function (alert_view) {
          if (data.callback) {
            data.callback($(alert_view.el).find(".alert-input-field").val());
          }
        },
      },
      {
        text: "Avbryt",
        type: "default",
      },
    ],
  });
  $(document.body).append(alert.render().el);
  document.activeElement.blur();
  alert.$el.find(".alert-input-field").focus();

  if (data.colorPicker) {
    alert.$el.find(".alert").css("overflow-y", "visible");
    alert.$el.find(".alert-input-field").minicolors({});
  }

  return alert;
};

function validateEmail(email) {
  var re = /\S+@\S+\.\S+/;
  return re.test(email);
}

AlertView.email = function (data) {
  var alert = new AlertView({
    title: data.title || "Fyll i värde",
    message: data.message || "Ange värdet i fältet",
    additional_classes: data.additional_classes || false,
    type: "email",
    input: false,
    input_default: data.input_default || "",
    empty_value: true,
    width: data.width || 400,
    buttons: [
      {
        text: "Ok",
        type: "primary",
        validator: function (alert_view) {
          var val = $(alert_view.el).find(".alert-email-field").val();
          if (alert_view.empty_value && !val) return true;

          if (!validateEmail(val)) {
            $(alert_view.el)
              .find(".alert-email-field")
              .closest(".form-group")
              .addClass("has-error");
            return false;
          }
          return true;
        },
        callback: function (alert_view) {
          if (data.callback) {
            data.callback($(alert_view.el).find(".alert-email-field").val());
          }
        },
      },
      {
        text: "Avbryt",
        type: "default",
      },
    ],
  });
  $(document.body).append(alert.render().el);
  document.activeElement.blur();
  alert.$el.find(".alert-input-field").focus();

  if (data.colorPicker) {
    alert.$el.find(".alert").css("overflow-y", "visible");
    alert.$el.find(".alert-input-field").minicolors({});
  }

  return alert;
};

function isValidDate(dateString) {
  // First check for the pattern
  if (!/^\d{4}-\d{1,2}-\d{1,2}$/.test(dateString)) return false;

  // Parse the date parts to integers
  var parts = dateString.split("-");
  var year = parseInt(parts[0], 10);
  var month = parseInt(parts[1], 10);
  var day = parseInt(parts[2], 10);

  // Check the ranges of month and year
  if (year < 1000 || year > 3000 || month == 0 || month > 12) return false;

  var monthLength = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

  // Adjust for leap years
  if (year % 400 == 0 || (year % 100 != 0 && year % 4 == 0))
    monthLength[1] = 29;

  // Check the range of the day
  return day > 0 && day <= monthLength[month - 1];
}

AlertView.selectDate = function (data) {
  var alert = new AlertView({
    title: data.title || "Välj datum",
    message: data.message || "Ange datum i fältet",
    additional_classes: data.additional_classes || false,
    type: "date",
    input_default: data.input_default || "",
    buttons: [
      {
        text: "Ok",
        type: "primary",
        validator: function (alert_view) {
          var val = $(alert_view.el).find(".alert-date-field").val();
          if (!isValidDate(val)) {
            $(alert_view.el)
              .find(".alert-date-field")
              .closest(".form-group")
              .addClass("has-error");
            return false;
          }
          return true;
        },
        callback: function (alert_view) {
          var val = $(alert_view.el).find(".alert-date-field").val();
          if (data.callback) {
            data.callback(val);
          }
        },
      },
      {
        text: "Avbryt",
        type: "default",
      },
    ],
  });
  $(document.body).append(alert.render().el);
  // document.activeElement.blur();
  // alert.$el.find('.alert-date-field').focus();

  alert.$el
    .find('[data-toggle="datepicker"]')
    .datepicker({
      showOtherMonths: true,
      selectOtherMonths: true,
      dateFormat: "yy-mm-dd",
      yearRange: "-1:+1",
      calendarWeeks: true,
      language: "sv",
    })
    .prev(".input-group-btn")
    .on("click", function (e) {
      e && e.preventDefault();
      $(e.currentTarget).siblings("input").focus();
    });

  return alert;
};

AlertView.select = function (data) {
  var alert = new AlertView({
    title: data.title,
    message: data.message,
    type: "select",
    select_options: data.options,
    select_default: data.select_default,
    buttons: [
      {
        text: "Ok",
        type: "primary",
        callback: function (alert_view) {
          data.callback($(alert_view.el).find(".alert-select-field").val());
        },
      },
      {
        text: "Avbryt",
        type: "default",
      },
    ],
  });
  $(document.body).append(alert.render().el);
  document.activeElement.blur();
  return alert;
};

AlertView.slider = function (title, message, slider_options, callback) {
  var alert = new AlertView({
    title: title,
    message: message,
    type: "input",
    slider: slider_options,
    buttons: [
      {
        text: "Ok",
        type: "primary",
        callback: () => callback(parseInt(alert.$slider_value.text())),
      },
      {
        text: "Avbryt",
        type: "default",
      },
    ],
  });
  $(document.body).append(alert.render().el);
  document.activeElement.blur();
  return alert;
};

const BasicDialog = Backbone.View.extend({
  tagName: "div",
  className: "alert-container",
  constructor: function () {
    // Close alert on escape key
    $(document).on("keyup", $.proxy(this.on_keyup, this));

    this.events = $.extend(this.events, {
      "click .close": "close",
    });

    // Call the original constructor
    Backbone.View.apply(this, arguments);
  },
  on_keyup: function (e) {
    if (e.keyCode == 27) {
      this.close();
    } else if (e.keyCode == 13) {
      if (this.save) {
        this.save(e);
      } else {
        e.preventDefault();
      }
    }
  },
  close: function () {
    $(document).off("keyup", $.proxy(this.on_keyup, this));
    this.trigger("close", this);
    this.remove();
  },
});

export { AlertView, BasicDialog };
